import React from 'react';

const Empty = ({ text }) => <div className="empty-component">{text}</div>;

export default Empty;
